import * as React from 'react';
import { Navigate } from 'react-router-dom';

import IsAdminQuery from '../components/auth/IsAdminQuery';
import Routing from '../Routing';
import withMainNavigation from './withMainNavigation';

class DashboardContainer extends React.Component<any, any> {
    private renderAdminDashboard = () => {
        return <Navigate to={Routing.BASKETS.getPath()} replace />;
    };

    private renderUserDashboard = () => {
        return <Navigate to={Routing.PLANTS.getPath()} replace />;
    };

    public render = (): JSX.Element => {
        return (
            <>
                <IsAdminQuery
                    renderAdmin={this.renderAdminDashboard}
                    renderUser={this.renderUserDashboard}
                />
            </>
        );
    };
}

export default withMainNavigation(DashboardContainer);
